/** The page's one call, kept out of the component. Shape and envelope are `@/api/bidList`'s. */
import type { DispatcherBidsPage } from '@numeo/types'
import { fetchBidList, type BidListQuery } from '@/api/bidList'

export type DispatcherBidsQuery = BidListQuery

export const fetchDispatcherBids = (query: DispatcherBidsQuery, signal?: AbortSignal): Promise<DispatcherBidsPage> =>
    fetchBidList<DispatcherBidsPage>('/gluon/dispatcher-bids', query, signal)
